/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { wordTimingSchema } from '../shared/word-timing-schema';

export const getUsageAudioCachedV1ResultSchema = z.discriminatedUnion('exists', [
  z.object({ exists: z.literal(false) }),
  z.object({
    exists: z.literal(true),
    value: z.object({
      audioUrl: z.string(),
      wordTimings: z.array(wordTimingSchema).optional(),
    }),
  }),
]);

export type IGetUsageAudioCachedV1Result = z.infer<typeof getUsageAudioCachedV1ResultSchema>;

export const getUsageAudioCachedV1ResponseSchema = createApiResponseSchema(
  getUsageAudioCachedV1ResultSchema,
) as z.ZodSchema<IAPI<IGetUsageAudioCachedV1Result>>;

export type IGetUsageAudioCachedV1Response = IAPI<IGetUsageAudioCachedV1Result>;
